<div class="cashflow-check-container">
    <div class="col-1">{{ 'aumico_annual_report_cashflow_difference_text' | i18next }}</div>
    <div class="col-2">{{ 'aumico_annual_report_cashflow_difference_should_be_zero_text' | i18next }}</div>
    <div class="col-3">{{ cashflowClosingDifference | finNumber }}</div>
    <div class="col-4">{{ cashflowOpeningDifference | finNumber }}</div>
</div>
